<template>
  <div class="d-flex h-100">
    <div class="d-flex flex-column" style="flex: 1" id="options-bar" >
      <form id="edit_custom_styles" @submit.prevent="saveSettings()" class="d-flex flex-column fullheight">
        <div class="d-flex spaced-xs">
          <a :href="'/creator/'+websiteid+'/settingspage'" class="btn btn-outline-primary" style="width: 38px; height: 38px; padding: 5px 6px; margin-right: 20px;"><span class="material-icons">arrow_back</span></a>
          <label class="d-flex m-0 mt-1" style="flex: 1; align-items: baseline;">
            <input type="checkbox" v-model="settingspage.use_stylesheet" style="margin-right: 5px;"> Gebruik eigen stijlen
          </label>
          <span><input type="submit" name="submit_custom_styles" value="Opslaan" class="btn btn-primary"></span>
        </div>
        <textarea class="textinput border-0 p-2" type="text" v-model="settingspage.custom_stylesheet"  placeholder="Voeg eigen stijlen hier" style="flex: 1;"></textarea>
      </form>
    </div>
    <div class="d-flex" style="flex: 2;" id="iframecontainer">
      <iframe id="userframe" class="align-self-stretch w-100 border-0" :src="'/viewer/'+websiteid">
      </iframe>
    </div>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
      websiteid: {
        type: String
      },
      readonly: {
        type: Boolean
      }
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        loading: false,
        settingspage: {}
      }
    },
    created () {
    },
    components: {
      InputDefault,
      AlertBar,
      Loader
    },
    methods: {
      saveSettings(){
          const requestOptions = {
            headers: authHeader()
          }

          const data = {
              websiteid: this.$route.params.websiteid,
              dbentry: 'settings',
              content: [this.settingspage]
          }

          axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
          .then(response => {
              this.editmode = false
              document.getElementById('userframe').contentWindow.location.reload();
          })
      },
      getSettings(){
          axios.get(process.env.VUE_APP_ROOT_API+'/settings/'+this.websiteid)
          .then(response => {
              this.settingspage = response.data.response.settings[0]
          })
      }
    },
    mounted(){
      this.getSettings()
    }
  }
</script>

<style>
</style>
